import { useRef, useEffect } from 'react'
import { useInView } from 'framer-motion'
import { EventNames } from '../types/misc.types'
import { trackEvent } from '../utils/appBridge'

export const useEliteLandingPageScrollEvent = ({
  sectionName,
  screenType
}: {
  sectionName: string
  screenType?: string
}) => {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true })

  useEffect(() => {
    if (isInView) {
      let detectedScreenType = screenType

      if (!detectedScreenType) {
        // Fallback to URL-based detection if screenType not provided
        if (window?.location?.href?.includes('elite-dashboard')) {
          detectedScreenType = 'MF_L2_Elite_Dashboard_Bottomsheet'
        } else {
          detectedScreenType = 'MF_Elite_Landing'
        }
      }

      trackEvent({
        eventName: EventNames.VScroll,
        payload: {
          scrollSection: sectionName,
          screenType: detectedScreenType
        }
      })
    }
  }, [isInView, screenType, sectionName])

  return sectionRef
}
